<template>
  <Modal
    fullscreen
    :transition-name="'slide-reveal-left'"
    class="overflow-hidden"
    @modal-ready="ready = true"
    @close="$emit('closed')"
  >
    <div class="bg-gray-900 px-16 h-screen overflow-auto ml-auto" @click.stop>
      <PagePreview :url="page.url" :visible="ready" />
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Ui/Modal.vue';
import PagePreview from '@/components/Ui/PagePreview.vue';

export default {
  name: 'ModalPagePreview',
  components: {
    Modal,
    PagePreview,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    redirectRoute: {
      type: [String, Object],
      default: '',
    },
  },
  data: () => ({
    ready: false,
  }),
};
</script>
